/* tslint:disable */
/* eslint-disable */
export enum AppConfigName {
  Logo = 'logo',
  Urls = 'urls',
  Messages = 'messages',
}
